import { useMutation } from '@tanstack/react-query';
import { axiosInstance } from '../../utils';

interface Payload {
  uploadId: string;
  name: string;
}
const uploadBroll = async (payload: Payload): Promise<any> => {
  const res = await axiosInstance.post('/api/broll/media-uploads', payload);
  return res.data;
};

export const useUploadBroll = () => {
  return useMutation(uploadBroll, { onSuccess: (data) => data });
};
